// validate email
const validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const validateConfirmEmail = (emailEl) => {
    const equalToName = emailEl.getAttribute('data-equal-name');
    const confirmEmailEl = document.querySelector(`input[name="${equalToName}"]`);
    if (emailEl.value === confirmEmailEl.value) {
        validate.removeError(confirmEmailEl);
    }
    return emailEl.value === confirmEmailEl.value;
}

// validate tel
const validatePhoneUK = (phone_number) => {
    return phone_number.length > 9 && phone_number.match(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/);
}

// validate date of birth
const validateBirth = (DOBFormElement) => {
    const date = DOBFormElement.value;
    const maxDate = DOBFormElement.getAttribute('data-max-date') === 'today' ? new Date() : new Date(DOBFormElement.getAttribute('data-max-date'));
    const dateSplit = date.split('/');
    const DOB = new Date(dateSplit[1] + '/' + dateSplit[0] +'/' + dateSplit[2]).getTime();
    const currDate = maxDate ? maxDate.getTime() : new Date().getTime();
    return currDate > DOB;
};

/**
 * Select element validation
 * @param selectFormElement
 * @returns {boolean}
 */
 const formCheckSelect = (selectFormElement) => {
    let error = false;
    const value = selectFormElement.value;
    if (value !== '' && parseInt(value) !== -1) {
        error = true;
    }
    return error;
}

/**
 * Radio elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckRadio = (radioFormElement) => {
    var radioName = radioFormElement.getAttribute('name');
    var radioOptions = document.querySelectorAll('[name="' + radioName + '"]');

    // loop all radio items with this name
    var error = false;
    for (const radioOption of radioOptions) {
        if (radioOption.checked == true) {
            error = true;
        }
    }
    return error;
}

/**
 * Checkbox elements validation
 * @param selectFormElement
 * @returns {boolean}
 */
const formCheckbox = (checkboxFormElement) => {
    var error = false;
    if (checkboxFormElement.checked == true) {
        error = true;
    }
    return error;
}

const validate = {
    settings: {
        valueMissingradio: 'Please select an option.',
        valueMissingselect: 'Please select an option.',
        valueMissingcheckbox: 'Please check this box to proceed.',
        email: 'Please enter a valid email address.',
        confirmEmail: 'Please ensure emails match.',
        generic: 'Please enter a value for this field.',
        tel: 'Please specify a valid phone number e.g. 01491 825522.',
        date: 'Please type in valid date.',
        messageTooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
        messageTooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
        messageRangeOverflow: 'Please select a value that is no more than {max}.',
        messageRangeUnderflow: 'Please select a value that is no less than {min}.',
        messagePatternMismatch: 'Please match the requested format.',
        beforeShowError: () => {},
        afterShowError: () => {},
        beforeRemoveError: () => {},
        afterRemoveError: () => {},
    },
    addErrorMsg: (field, errorMsg) => {
        let parentElement = field.closest('.form-group');
        var fieldErrorMsgElement = document.createElement('div');
        fieldErrorMsgElement.classList.add('error-message');

        if (!parentElement.lastElementChild.classList.contains('error-message')) {
            const fieldErrorMessage = document.createTextNode(errorMsg);
            fieldErrorMsgElement.appendChild(fieldErrorMessage);
            parentElement.appendChild(fieldErrorMsgElement);
        }

        parentElement.classList.add('error');
    },
    removeErrorMsg: (field) => {
        const parentElement = field.closest('.form-group');

        if (parentElement.classList.contains('error')) {
            parentElement.classList.remove('error');
            const errorEl = parentElement.querySelector('.error-message');
            parentElement.removeChild(errorEl);
        }
    },
    hasError: (field) => {
        const localSettings = validate.settings;

        if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

        const validity = field.validity;

        if (field.id == 'customDonationAmount') {
            const value = parseFloat(field.value);

            if (typeof value == 'number' && value >= 0.3) {
                return;
            }

            return 'Please enter an amount greater than £0.30.';
        }

        if (field.type === 'select-one') {
            return !formCheckSelect(field) ? localSettings.valueMissingselect : '';
        } else if (field.type === 'email') {
            return !validateEmail(field.value) ? localSettings.email : '';
        } else if (field.type === 'tel') {
            return !validatePhoneUK(field.value) ? localSettings.tel : '';
        }

        if (validity.valid) return;

        if (validity.valueMissing) {
            switch (field.type) {
                case 'select-one':
                    return !formCheckSelect(field) ? localSettings.valueMissingselect : '';

                case 'radio':
                    return !formCheckRadio(field) ? localSettings.valueMissingradio : '';

                case 'checkbox':
                    return !formCheckbox(field) ? localSettings.valueMissingcheckbox : '';

                default:
                    return localSettings.generic;
            }
        }

        if (validity.typeMismatch) {
            if (field.type === 'email' && !validateEmail(field.value)) return localSettings.email;
            if (field.type === 'tel' && !validatePhoneUK(field.value)) return localSettings.tel;
        }

        if (validity.tooShort) {
            return localSettings.messageTooShort.replace('{minLength}', field.getAttribute('minLength')).replace('{length}', field.value.length);
        }

        if (validity.tooLong) {
            return localSettings.messageTooLong.replace('{minLength}', field.getAttribute('maxLength')).replace('{length}', field.value.length);
        }

        if (validity.rangeOverflow) {
            return localSettings.messageRangeOverflow.replace('{max}', field.getAttribute('max'));
        }

        if (validity.rangeUnderflow) {
            return localSettings.messageRangeUnderflow.replace('{min}', field.getAttribute('min'));
        }

        if (validity.patternMismatch) {
            return localSettings.messagePatternMismatch;
        }

        return localSettings.generic;
    },
    removeError: (field) => {
        const localSettings = validate.settings;

        localSettings.beforeRemoveError(field);
        validate.removeErrorMsg(field);
        localSettings.afterRemoveError(field);
    },
    showError: (field, error) => {
        const localSettings = validate.settings;

        localSettings.beforeShowError(field, error);
        const errorMsgEl = field.parentNode.querySelectorAll('.error-message');
        if (!errorMsgEl.length) {
            validate.addErrorMsg(field, error);
        } else {
            errorMsgEl[0].innerHTML = error;
        }
        localSettings.afterShowError(field, error);
    },
    inputHandler: function (event) {
        if (!event.target.form) return;

        const error = validate.hasError(event.target);
        if (error) {
            validate.showError(event.target, error);
            return;
        }
        validate.removeError(event.target);
    },
};

export default validate;